import { render, staticRenderFns } from "./RatingAdminCheckDeptRatingAllRootView.vue?vue&type=template&id=5d40da44"
import script from "./RatingAdminCheckDeptRatingAllRootView.vue?vue&type=script&lang=js"
export * from "./RatingAdminCheckDeptRatingAllRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports